import React from 'react';
import CreditReasonTable from './creditReasonTable';
import ConfirmationModal from '../../../common/confirmationModal';
import OneInputEditModal from '../../../common/OneInputEditModal';

export default function CreditReasons({
	addvalue,
	editValue,
	onChange,
	onUpdate,
	onAdd,
	creditReasons,
	onReasonUpdateOrDelete,
	onDelete,
	onChangeEdit,
}) {
	return (
		<>
			<div className="comp-heading">
				<div className="row">
					<div className="col-lg-4">
						<label>Credit Reasons</label>
					</div>
				</div>
			</div>
			<br />
			<div className="panel panel-default">
				<div className="panel-body">
					<div className="row" id="settings-field">
						<div className="col-md-2 col-xs-9">
							<label className="input-label" htmlFor="credit-reason">
								* Credit Reason
							</label>
							<input
								onChange={e => onChange(e)}
								value={addvalue}
								className="form-control"
								id="credit-reason"
							/>
						</div>
						<div className="col-xs-2" id="system-add-btn">
							<button onClick={() => onAdd()} className="btn btn-success btn-sm">
								Add
							</button>
						</div>
					</div>
				</div>
			</div>
			<div className="panel panel-default">
				<div className="panel-body">
					<CreditReasonTable
						creditReasons={creditReasons}
						onReasonUpdateOrDelete={data => onReasonUpdateOrDelete(data)}
					/>
				</div>
			</div>
			<ConfirmationModal onDelete={() => onDelete()} item="Credit Reason" />
			<OneInputEditModal
				label="Credit Reason"
				value={editValue}
				onChange={e => onChangeEdit(e)}
				onUpdate={() => onUpdate()}
			/>
		</>
	);
}
